import React from "react";
import { alpha, GlobalStyles as MuiGlobalStyles } from "@mui/material";

const GlobalStyles = () => (
  <MuiGlobalStyles
    styles={(theme) => ({
      "*": {
        boxSizing: "border-box",
        margin: 0,
        padding: 0,
        scrollbarWidth: "thin",
        scrollbarColor:
          theme.palette.mode === "dark"
            ? "rgba(255,255,255,0.25) transparent"
            : "rgba(0,0,0,0.2) transparent"
      },
      "*::-webkit-scrollbar": {
        width: "6px",
        height: "6px"
      },
      "*::-webkit-scrollbar-track": {
        background: "transparent"
      },
      "*::-webkit-scrollbar-thumb": {
        backgroundColor:
          theme.palette.mode === "dark" ? "rgba(255,255,255,0.25)" : "rgba(0,0,0,0.2)",
        borderRadius: "3px"
      },
      "*::-webkit-scrollbar-thumb:hover": {
        backgroundColor:
          theme.palette.mode === "dark" ? "rgba(255,255,255,0.4)" : "rgba(0,0,0,0.35)"
      },
      html: {
        "-webkit-font-smoothing": "antialiased",
        "-moz-osx-font-smoothing": "grayscale"
      },
      a: {
        textDecoration: "none"
      },
      "div[data-lastpass-icon-root=true]": {
        display: "none!important"
      },
      ".tiny-preview *": {
        margin: "revert",
        padding: "revert",
        boxSizing: "content-box"
      },
      ".tox-custom-editor:focus-within, .tox .tox-listboxfield .tox-listbox--select:focus, .tox .tox-textarea-wrap:focus-within, .tox .tox-textarea:focus, .tox .tox-textfield:focus":
        {
          borderColor: `${theme.palette.primary.main} !important`,
          boxShadow: `0 0 0 1px ${theme.palette.primary.main} !important`
        },
      ".tox": {
        "& .tox-editor-header": {
          padding: "4px 0 !important"
        },
        "& .tox-collection--toolbar .tox-collection__item--active:focus::after, .tox-tbtn:focus::after, .tox-split-button:focus::after, .tox-collection__item.tox-collection__item--active::after":
          {
            boxShadow: `0 0 0 2px ${theme.palette.primary.main} inset !important`
          },
        "& .tox-tbtn:active, .tox-tbtn--active, .tox-tbtn--enabled, .tox-tbtn--enabled:focus, .tox-tbtn--enabled:hover":
          {
            backgroundColor: `${alpha(theme.palette.primary.main, 0.2)} !important`
          },
        "&  .tox-collection--toolbar .tox-collection__item--enabled,  .tox-collection--toolbar .tox-collection__item--enabled.tox-collection__item--active,  .tox-collection--toolbar .tox-collection__item--enabled.tox-collection__item--active:hover":
          {
            backgroundColor: `${alpha(theme.palette.primary.main, 0.5)} !important`
          },
        "& .tox-insert-table-picker .tox-insert-table-picker__selected, .tox-collection--list .tox-collection__item--active":
          {
            backgroundColor: `${theme.palette.primary.main} !important`
          },
        "& .tox-edit-area::before": {
          borderColor: `${theme.palette.primary.main} !important`
        }
      },
      ".tox-tinymce-aux": {
        zIndex: "1305!important",
        "& > div": {
          "& > .tox-toolbar__overflow": {},
          "& > .tox-editor-container": {
            "& > .tox-editor-header": {
              "& > .tox-toolbar-overlord": {
                backgroundColor: "transparent!important"
              }
            }
          },
          "& .tox-dialog__body-nav-item--active": {
            borderBottom: `2px solid ${theme.palette.primary.main} !important`,
            color: `${theme.palette.primary.main} !important`
          },

          "& .tox-dialog__footer": {
            "& .tox-button": {
              backgroundColor: `${theme.palette.primary.main} !important`,
              borderColor: `${theme.palette.primary.main} !important`
            },
            "& .tox-button.tox-button--secondary": {
              backgroundColor: `${theme.palette.grey[100]} !important`,
              borderColor: `${theme.palette.grey[100]} !important`
            }
          }
        },
        "& > .tox-dialog-wrap > .tox-dialog--width-md": {
          height: "500px",
          "& .tox-textarea-wrap:focus-within, .tox-textarea:focus, .tox-textfield:focus": {
            borderColor: theme.palette.primary.main,
            boxShadow: `0 0 0 2px ${alpha(theme.palette.primary.main, 0.5)}`
          }
        }
      },
      // TODO -> create new dialog component with overrides
      ".MuiDialogContent-root": {
        padding: `${theme.spacing(2, 3)}!important`
      },
      ".MuiDialogActions-root": {
        padding: `${theme.spacing(1, 3)}!important`
      },
      ".color-picker-button": {
        display: "flex",
        alignItems: "center",

        "& > div": {
          minWidth: "40px",
          minHeight: "25px",
          border: `3px solid ${theme.palette.primary.main}`,
          marginRight: theme.spacing(1.5)
        }
      },
      dropzone: {
        position: "relative",
        outline: "none",
        border: `1px solid ${theme.palette.mode === "dark" ? "#606060" : "#c0c0c0"}`,
        borderRadius: "4px",
        minHeight: "100px",
        padding: theme.spacing(1.5),
        "& > .drop-text": {
          position: "absolute",
          zIndex: "1",
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
          textAlign: "center",
          color: theme.palette.mode === "dark" ? theme.palette.common.white : theme.palette.grey[600]
        }
      },
      ".mobile-html-body-wrapper": {
        width: "100%",
        overflow: "hidden",
        "& img, & .image-token > img": {
          maxWidth: "100% !important",
          height: "auto !important"
        }
      },
      ".bi-alert": {
        color: theme.palette.primary.main,
        "& .MuiAlert-icon": {
          alignItems: "center",
          opacity: 1,
          "& svg": {
            color: theme.palette.primary.main,
            width: "24px",
            height: "24px"
          }
        }
      }
    })}
  />
);

export default GlobalStyles;
